import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AdminLayout from "../../components/admin/AdminLayout";
import { MagnifyingGlass, Eye } from "@phosphor-icons/react";

export default function AdminOutlets() {
  const [outlets, setOutlets] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchOutlets = async (q = "") => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/outlets?search=${encodeURIComponent(q)}&limit=50`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("rs_token")}` } }
      );
      if (!res.ok) throw new Error("Failed to load outlets");
      const data = await res.json();
      setOutlets(data);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOutlets(); }, []);
  useEffect(() => { const t = setTimeout(() => fetchOutlets(search), 300); return () => clearTimeout(t); }, [search]);

  return (
    <AdminLayout>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="relative flex-1 max-w-md">
            <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-muted)]" />
            <input placeholder="Search outlets..." className="input-pop pl-9 w-full" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="text-sm text-[var(--ink-muted)]">{outlets.length} results</div>
        </div>

        <div className="card-pop overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 text-left" style={{ borderColor: "var(--border)" }}>
                <th className="py-2 px-3 font-bold">Outlet</th>
                <th className="py-2 px-3 font-bold">Owner</th>
                <th className="py-2 px-3 font-bold text-right">Scans</th>
                <th className="py-2 px-3 font-bold text-right">Spins</th>
                <th className="py-2 px-3 font-bold text-right">Redeemed</th>
                <th className="py-2 px-3 font-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={6} className="py-8 text-center text-[var(--ink-muted)]">Loading...</td></tr>}
              {!loading && outlets.length === 0 && <tr><td colSpan={6} className="py-8 text-center text-[var(--ink-muted)]">No outlets found</td></tr>}
              {outlets.map((o) => (
                <tr key={o.id} className="border-b hover:bg-gray-50 transition-colors" style={{ borderColor: "var(--border)" }}>
                  <td className="py-2.5 px-3 font-medium">{o.name}</td>
                  <td className="py-2.5 px-3">{o.users?.name}</td>
                  <td className="py-2.5 px-3 text-right">{o.scans_count}</td>
                  <td className="py-2.5 px-3 text-right">{o.spins_count}</td>
                  <td className="py-2.5 px-3 text-right">{o.redemptions_count}</td>
                  <td className="py-2.5 px-3 text-center">
                    <Link to={`/admin/outlets/${o.id}`} className="p-1.5 rounded hover:bg-orange-100 text-orange-600 inline-block" title="View">
                      <Eye size={16} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}